
<app-container title="{{'Places'|translate}}">
    <app-content>
       
                <app-gridview [dataSource]="placeModel" [gridColumns]="gridColumns" [keyExpr]="'placeId'">
                </app-gridview>
            
    </app-content>
</app-container>